/**
 * Énumération représentant les types de documents pour les véhicules
 */
export enum TypeDocument {
    CARTE_GRISE = 1,
    ASSURANCE = 2 ,
    AUTORISATION = 3
}
